import React from 'react'
import ReactECharts from 'echarts-for-react'
import { EChartsOption } from 'echarts'
import { useTheme } from '../../../components/ThemeProvider'
import { getThemeSecondaryColor } from '../../../utils/themeConfig'

interface SpecialPeriodApplicationRecordsChartProps {
  data: any
}

export default function SpecialPeriodApplicationRecordsChart({ data }: SpecialPeriodApplicationRecordsChartProps) {
  const theme = useTheme()

  const options: EChartsOption = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    legend: {
      data: ['周末申请次数', '周末机构数', '夜间申请次数', '夜间机构数'],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: ['近7天', '近15天', '近1月', '近3月', '近6月', '近1年'],
      axisLabel: {
        fontSize: 10,
      },
    },
    yAxis: {
      type: 'value',
      min: 0,
      axisLabel: {
        formatter: '{value}',
      },
    },
    series: [
      {
        name: '周末申请次数',
        type: 'bar',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: theme?.primaryColor,
        },
        data: [
          data?.nb_d7_week_apply_count ?? 0,
          data?.nb_d15_week_apply_count ?? 0,
          data?.nb_m1_week_apply_count ?? 0,
          data?.nb_m3_week_apply_count ?? 0,
          data?.nb_m6_week_apply_count ?? 0,
          data?.nb_m12_week_apply_count ?? 0,
        ],
      },
      {
        name: '周末机构数',
        type: 'bar',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: getThemeSecondaryColor(theme?.type),
        },
        data: [
          data?.nb_d7_week_apply_org_count ?? 0,
          data?.nb_d15_week_apply_org_count ?? 0,
          data?.nb_m1_week_apply_org_count ?? 0,
          data?.nb_m3_week_apply_org_count ?? 0,
          data?.nb_m6_week_apply_org_count ?? 0,
          data?.nb_m12_week_apply_org_count ?? 0,
        ],
      },
      {
        name: '夜间申请次数',
        type: 'bar',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: '#F59E0B',
        },
        data: [
          data?.nb_d7_night_apply_count ?? 0,
          data?.nb_d15_night_apply_count ?? 0,
          data?.nb_m1_night_apply_count ?? 0,
          data?.nb_m3_night_apply_count ?? 0,
          data?.nb_m6_night_apply_count ?? 0,
          data?.nb_m12_night_apply_count ?? 0,
        ],
      },
      {
        name: '夜间机构数',
        type: 'bar',
        label: {
          show: true,
          color: '#ffffff',
          fontSize: 10,
        },
        itemStyle: {
          color: '#F97316',
        },
        data: [
          data?.nb_d7_night_apply_org_count ?? 0,
          data?.nb_d15_night_apply_org_count ?? 0,
          data?.nb_m1_night_apply_org_count ?? 0,
          data?.nb_m3_night_apply_org_count ?? 0,
          data?.nb_m6_night_apply_org_count ?? 0,
          data?.nb_m12_night_apply_org_count ?? 0,
        ],
      },
    ],
  }

  return <ReactECharts option={options} style={{ height: '400px' }} />
}
